export enum Query {
    QUERY = 'QUERY',
    DISTANCE = 'DISTANCE'
}
